<template>
  <div :class="['week-days-header', { 'show-week-num': showWeekNumTitle }]">
    <div class="week-day-cell" v-if="showWeekNumTitle">Нед.</div>
    <div
      :class="[
        'week-day-cell',
        { 'is-weekend': dayIndex === 0 || dayIndex === 6 },
      ]"
      v-for="dayIndex in daysList"
    >
      {{ locale.weekDayShortNames[dayIndex] }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { locale } from "../../constants";

const props = defineProps({
  /**Показать заголовок для номера недели */
  showWeekNumTitle: {
    type: Boolean,
    default: false,
  },
});

const daysList = [1, 2, 3, 4, 5, 6, 0];
</script>

<style lang="scss" scoped>
.week-days-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);

  &.show-week-num {
    grid-template-columns: var(--tir-pm-datepicker__week-num-cell-w) repeat(
        7,
        1fr
      );

    .week-day-cell {
      height: var(--tir-pm-datepicker__week-num-h);
    }
  }
}
.week-day-cell {
  height: var(--tir-pm-datepicker__week-day-cell-size);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  padding: var(--tir-pm-datepicker__week-day-cell-padding);
  color: var(--tir-pm-datepicker__week-day-cell-color);
  font-size: var(--tir-pm-datepicker__week-day-cell-fs);
  font-weight: var(--tir-pm-datepicker__week-day-cell-fw);
  line-height: var(--tir-pm-datepicker__week-day-cell-lh);

  &.is-weekend {
    color: var(--tir-pm-datepicker__week-day-cell-weekend-color);
  }
}
</style>
